import { TextInput } from '@interstate/components/TextInput';

import FieldOverrideIndicator from './FieldOverrideIndicator.interstate';
import { useLeaseTermField } from './hooks/useLeaseTermField';

const LeaseTermField = ({ isSummaryTab }: { isSummaryTab?: boolean }) => {
    const { label, overrideIndicatorProps, inputProps } = useLeaseTermField({ isSummaryTab });

    return (
        <FieldOverrideIndicator {...overrideIndicatorProps}>
            <TextInput label={label} {...inputProps} />
        </FieldOverrideIndicator>
    );
};

export default LeaseTermField;
